var modules_436816d0 = {"container":"_zma19j","rotate":"_1egw2jv","svg":"_18rc8lp","loading":"_1v0isrp","circle":"_1lnfydr","circle-1":"_16wm4ah","circle-2":"_127quu6","loading-circle":"_1ix5zke","size-16":"_15mtib4","size-20":"_ez6yti","size-24":"_rycsy2","size-28":"_17ww7k7"};
import "../../../assets/r8exajIv.css";

export { modules_436816d0 as default };
//# sourceMappingURL=Spinner.module.less.js.map
